
import React, {useEffect} from 'react';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import '../../../styles/DivisionManager.css'
import {TreeViewBaseItem} from '@mui/x-tree-view/models';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {getWithExpiry, refreshToken} from "../../../globals/GlobalFunctions";
import {GlobalConstants} from "../../../globals/GlobalConstants";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Checkbox from "@mui/material/Checkbox";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

function DivisionManager() {
    const [divisions, setDivisions] = React.useState([]);
    const [validationText, setValidationText] = React.useState("");
    const [successMessage, setSuccessMessage] = React.useState("");
    const [currentDivision, setCurrentDivision] = React.useState({group_ID: "", division_ID: "", division_name: "", division_contract_coverage_End: "",
        division_contract_coverage_Start: "", division_Network1: {networkID: "", networkDescription: ""}, division_Network1_Priority: "",
        division_Network2: {networkID: "", networkDescription: ""}, division_Network3: {networkID: "", networkDescription: ""},
        division_plan_Year_1: "", division_plan_Year_2: "", original_Date: "", plan_Year_1_From_Date: "", plan_Year_1_Thru_Date: "", plan_Year_2_From_Date: "",
        plan_Year_2_Thru_Date: "", division_plans: [], division_Network2_Priority: "", division_Network3_Priority: "", vbasoftware_database: "CoastalAdminTest",
        allDivisions: false, contractChange: false, copyNetwork: false, reenroll: false, planMappings: [{original_Plan_ID: "", mapped_Plan_ID: ""}], newContractPlans: [],
        division_Network1_Eff_Date: "", division_Network2_Eff_Date: "", division_Network3_Eff_Date: ""});
    const [copyDivision, setCopyDivision] = React.useState({destinationDivisionID: "",
        destinationDivisionName: ""});
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [validationError, setValidationError] = React.useState(false);
    const [validationSuccess, setValidationSuccess] = React.useState(false);
    const [currentDB, setCurrentDB] = React.useState("CoastalAdminTest");
    const [plans, setCurrentDivisionPlans] = React.useState([]);
    const [networks, setNetworks] = React.useState([{networkID: "", networkDescription: ""}]);
    const [isUpdate, setIsUpdate] = React.useState(false);
    const [hasFirstPlanYear, setHasFirstPlanYear] = React.useState(false);
    const [hasSecondPlanYear, setHasSecondPlanYear] = React.useState(false);
    const [hasActiveContract, setHasActiveContract] = React.useState(false);

    const handleChange = React.useCallback((e: any) => setCurrentDivision((prev: any) => ({ ...prev, [e.target.name]: e.target.value })), []);

    const handleCopyChange = React.useCallback((e: any) => setCopyDivision((prev: any) => ({ ...prev, [e.target.name]: e.target.value })), []);

    const handleCheck = React.useCallback((e: any) => setCurrentDivision((prev: any) => ({ ...prev, [e.target.name]: e.target.checked})), []);

    const handlePlanSelect = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentDivision((prev: any) => ({...prev, division_plans: newValue}))
        }
        else {
            setCurrentDivision((prev: any) => ({...prev, division_plans: ""}))
        }
    }, []);

    const handlenewContractPlanSelect = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentDivision((prev: any) => ({...prev, newContractPlans: newValue}))
        }
        else {
            setCurrentDivision((prev: any) => ({...prev, newContractPlans: ""}))
        }
    }, []);

    const handleNetwork1Select = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentDivision((prev: any) => ({ ...prev, division_Network1: {networkID: newValue.networkID, networkDescription:  newValue.networkDescription } }))
        }
        else {
            setCurrentDivision((prev: any) => ({ ...prev, division_Network1: {networkID: "", networkDescription:  "" } }))
        }
    }, []);

    const handleNetwork2Select = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentDivision((prev: any) => ({ ...prev, division_Network2: {networkID: newValue.networkID, networkDescription:  newValue.networkDescription } }))
        }
        else {
            setCurrentDivision((prev: any) => ({ ...prev, division_Network2: {networkID: "", networkDescription:  "" } }))
        }
    }, []);

    const handleNetwork3Select = React.useCallback((e: any, newValue: any) => {
        if(newValue !== null) {
            setCurrentDivision((prev: any) => ({ ...prev, division_Network3: {networkID: newValue.networkID, networkDescription:  newValue.networkDescription } }))
        }
        else {
            setCurrentDivision((prev: any) => ({ ...prev, division_Network3: {networkID: "", networkDescription:  "" } }))
        }
    }, []);

    const handleOriginalDateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, original_Date: e.format('MM/DD/YYYY')  }));
    }

    const handleCovStartDateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, division_contract_coverage_Start: e.format('MM/DD/YYYY') }));
    }

    const handleCovEndDateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, division_contract_coverage_End: e.format('MM/DD/YYYY') }));
    }

    const handlePlanYear1FromDateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, plan_Year_1_From_Date: e.format('MM/DD/YYYY') }));
    }

    const handlePlanYear1ThruDateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, plan_Year_1_Thru_Date: e.format('MM/DD/YYYY') }));
    }

    const handlePlanYear2FromDateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, plan_Year_2_From_Date: e.format('MM/DD/YYYY') }));
    }

    const handlePlanYear2ThruDateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, plan_Year_2_Thru_Date: e.format('MM/DD/YYYY') }));
    }

    const handleDivision_Network1_Eff_DateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, division_Network1_Eff_Date: e.format('MM/DD/YYYY') }));
    }

    const handleDivision_Network2_Eff_DateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, division_Network2_Eff_Date: e.format('MM/DD/YYYY') }));
    }

    const handleDivision_Network3_Eff_DateChange = (e: any) => {
        setCurrentDivision((prev: any) => ({ ...prev, division_Network3_Eff_Date: e.format('MM/DD/YYYY') }));
    }

    const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);

    const initialDivisionState = {
        group_ID: "",
        division_ID: "",
        division_name: "",
        division_contract_coverage_End: "",
        division_contract_coverage_Start: "",
        division_Network1: {networkID: "", networkDescription: ""},
        division_Network1_Priority: "",
        division_Network2: {networkID: "", networkDescription: ""},
        division_Network2_Priority: "",
        division_Network3: {networkID: "", networkDescription: ""},
        division_Network3_Priority: "",
        division_plan_Year_1: "",
        division_plan_Year_2: "",
        original_Date: "",
        plan_Year_1_From_Date: "",
        plan_Year_1_Thru_Date: "",
        plan_Year_2_From_Date: "",
        plan_Year_2_Thru_Date: "",
        division_plans: [],
        vbasoftware_database: "CoastalAdminTest",
        allDivisions: false,
        contractChange: false,
        copyNetwork: false,
        reenroll: false,
        planMappings: [{original_Plan_ID: "", mapped_Plan_ID: ""}],
        newContractPlans: [],
        division_Network1_Eff_Date: "",
        division_Network2_Eff_Date: "",
        division_Network3_Eff_Date: ""
    }

    const initialCopyDivision = {
        destinationDivisionID: "",
        destinationDivisionName: ""
    }

    const handleValidationClose = () => {
        setValidationError(false);
    }

    const handleAllDivisionsSelect = () => {
        currentDivision.allDivisions = true;
        setIsLoading(true);
        handleAllDivisionClose();
        setLoading(true);
        saveDivision();
    }

    const handleOneDivisionsSelect = () => {
        handleAllDivisionClose();
        setIsLoading(true);
        setLoading(true);
        saveDivision();
    }

    const handleAllDivisionClose = () => {
        setValidationSuccess(false);
    }

    let token = localStorage.getItem('jwt');
    //console.log('jwt', token);

    // type treeDivisions = TreeViewBaseItem<{
    //     id: string;
    //     //description: string;
    //     //plan_type: string;
    //     label: string;
    //     children: TreeViewBaseItem<{  id: string, label: string}>,
    // }>;

    const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
        color: theme.palette.grey[200],
        [`& .${treeItemClasses.content}`]: {
            //borderRadius: theme.spacing(0.5),
            //padding: theme.spacing(0.5, 1),
            //margin: theme.spacing(0.2, 0),
            [`& .${treeItemClasses.label}`]: {
                fontSize: '1.4vh',
                fontWeight: 500,
            },
        }}),
        );


    const getDivision = async (groupID : string, divisionID : string) => {
        setIsLoading(true);
        refreshToken();
        await axios
            .get(
                localStorage.getItem('baseURL') + 'division/get/' + groupID + '/' + divisionID + '/' + currentDB,
                {headers: {'Authorization': `Bearer ${token}`}}
            )
            .then((response) => {
                console.log(response);
                setCurrentDivision({...currentDivision, ...response.data});
                setCopyDivision({...initialCopyDivision});
                setIsUpdate(true);
                if (response.data.division_plan_Year_1 && response.data.division_plan_Year_1.length > 0) {
                    setHasFirstPlanYear(true);
                }
                if (response.data.division_plan_Year_2 && response.data.division_plan_Year_2.length > 0) {
                    setHasSecondPlanYear(true);
                }
                if (response.data.division_contract_coverage_Start && response.data.division_contract_coverage_Start.length > 0) {
                    setHasActiveContract(true);
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
                setValidationText(error.response.data);
                setValidationError(true);
            });
    }

    function handleTreeViewSelect(event: React.SyntheticEvent, id: string | null) {
        if (id && id.includes("-")){
            setCurrentDivision({...initialDivisionState});
            let idArray = id.split("-");
            getDivision(idArray[0], idArray[1]);
        }
    }

    const clearDivision = () => {
        setCurrentDivision({...initialDivisionState});
        setCopyDivision({...initialCopyDivision})
        setIsUpdate(false);
        setHasActiveContract(false);
        setHasFirstPlanYear(false);
        setHasSecondPlanYear(false);
    }

    useEffect(() => {
        setIsLoading(true);
        getDivisionList();
        getPlanIDs();
        getNetworks();
        clearDivision();
    }, [currentDB]);

    const getDivisionList = async () => {
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null || vbapi_Token === ""){
            vbapi_Token = "empty";
        }
        const response =
            await axios
                .get(
                    localStorage.getItem('baseURL') + 'division/getList/' + currentDB + '/' + vbapi_Token,
                    {headers: {'Authorization': `Bearer ${token}`}}
                );
        //console.log(response);
        setDivisions(response.data.sort((a : any, b : any) => Number(a.id) > Number(b.id) ? 1 : -1));
        setIsLoading(false);
    }

    // const getGroupDivisions = async (groupID : string) => {
    //     refreshToken();
    //     const response =
    //         await axios
    //             .get(
    //                 localStorage.getItem('baseURL') + 'division/getList/' + groupID,
    //                 {headers: {'Authorization': `Bearer ${token}`}}
    //             );
    //     console.log(response);
    //     setDivisions(response.data);
    // }

    const getPlanIDs = async () => {
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null || vbapi_Token === ""){
            vbapi_Token = "empty";
        }
        const response =
            await axios
                .get(
                    localStorage.getItem('baseURL') + 'plan/getIDs/' + currentDB + '/' + vbapi_Token,
                    {headers: {'Authorization': `Bearer ${token}`}}
                );
        //console.log(response);
        setCurrentDivisionPlans(response.data);
    }

    const getNetworks = async () => {
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null || vbapi_Token === ""){
            vbapi_Token = "empty";
        }
        const response =
            await axios
                .get(
                    localStorage.getItem('baseURL') + 'network/getList/' + currentDB + '/' + vbapi_Token,
                    {headers: {'Authorization': `Bearer ${token}`}}
                );
        //console.log(response);
        setNetworks(response.data);
    }

    const validateDivision = () => {
        setLoading(true);
        setIsLoading(true);
        if (!(currentDivision.division_ID.length > 0)) {
            setLoading(false);
            setValidationText("ID is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.division_name.length > 0)) {
            setLoading(false);
            setValidationText("Name is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.original_Date.length > 0)) {
            setLoading(false);
            setValidationText("Original Date is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.division_contract_coverage_Start.length > 0)) {
            setLoading(false);
            setValidationText("Coverage Start is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.division_contract_coverage_End.length > 0)) {
            setLoading(false);
            setValidationText("Coverage End is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.division_plan_Year_1.length > 0)) {
            setLoading(false);
            setValidationText("Plan Year 1 is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.plan_Year_1_From_Date.length > 0)) {
            setLoading(false);
            setValidationText("Plan Year 1 is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.plan_Year_1_Thru_Date.length > 0)) {
            setLoading(false);
            setValidationText("Plan Year 1 is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.division_Network1.networkID.length > 0) || !(currentDivision.division_Network1_Eff_Date)) {
            setLoading(false);
            setValidationText("Network 1 is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if ((currentDivision.division_Network1.networkID.length > 0 && (currentDivision.division_Network1_Eff_Date == null || currentDivision.division_Network1_Eff_Date.length === 0)) ||
            (currentDivision.division_Network2 != null && currentDivision.division_Network2.networkID.length > 0  && (currentDivision.division_Network1_Eff_Date == null || currentDivision.division_Network2_Eff_Date.length === 0)) ||
            (currentDivision.division_Network3 != null && currentDivision.division_Network3.networkID.length > 0 && (currentDivision.division_Network1_Eff_Date == null || currentDivision.division_Network3_Eff_Date.length === 0))) {
            setLoading(false);
            setValidationText("Networks require effective dates!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (!(currentDivision.division_plans.length > 0)) {
            setLoading(false);
            setValidationText("At least one plan is required!")
            setValidationError(true);
            setIsLoading(false);
        }
        else if (currentDivision.contractChange && currentDivision.division_contract_coverage_End === "2222-12-31T00:00:00Z") {
            setLoading(false);
            setValidationText("On contract change please change the contract end!")
            setValidationError(true);
            setIsLoading(false);
        }
        else {
            if(currentDivision.contractChange && currentDivision.reenroll){
                if(currentDivision.division_plans.length !== currentDivision.newContractPlans.length){
                    setLoading(false);
                    setValidationText("Contract changes require matching plan mappings when re-enrolling!")
                    setValidationError(true);
                    setIsLoading(false);
                }
                else{
                    if(currentDivision.planMappings == null){
                        currentDivision.planMappings = [];
                    }
                    for (let i = 0; i < currentDivision.division_plans.length; i++){
                        currentDivision.planMappings.push({original_Plan_ID: currentDivision.division_plans[i], mapped_Plan_ID: currentDivision.newContractPlans[i]});
                    }
                    if(isUpdate){
                        setLoading(false);
                        setIsLoading(false);
                        setValidationSuccess(true);
                    }
                    else{
                        saveDivision();
                    }
                }
            }
            else{
                if(isUpdate){
                    setLoading(false);
                    setIsLoading(false);
                    setValidationSuccess(true);
                }
                else {
                    saveDivision();
                }
            }
        }
    }

    const validateCopy = () => {
        setLoading(true);
        setIsLoading(false);
        if (!(currentDivision.division_ID.length > 0) || !(copyDivision.destinationDivisionName.length > 0) ||
            !(copyDivision.destinationDivisionID.length > 0 || !(currentDivision.group_ID.length > 0))) {
            setLoading(false);
            setIsLoading(false);
            setValidationText("Division IDs, copy name, and group are required to copy a division")
            setValidationError(true);
        }
        else {
            copyNewDivision();
        }
    }

    const saveDivision = async () => {
        refreshToken();
        currentDivision.vbasoftware_database = currentDB;
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'division/put',
                    currentDivision,
                    {headers: {'Authorization': `Bearer ${token}`}}
                ).then(() => {
                    setLoading(false);
                    setSuccessMessage("Division Saved Successfully!");
                    setSuccessAlert(true);
                    if (currentDivision.division_plan_Year_1 && currentDivision.division_plan_Year_1.length > 0) {
                        setHasFirstPlanYear(true);
                    }
                    if (currentDivision.division_plan_Year_2 && currentDivision.division_plan_Year_2.length > 0) {
                        setHasSecondPlanYear(true);
                    }
                    if (currentDivision.division_contract_coverage_Start && currentDivision.division_contract_coverage_Start.length > 0) {
                        setHasActiveContract(true);
                    }
                    getDivisionList();
                    if (currentDivision.contractChange) {
                        setTimeout(() => getDivision(currentDivision.group_ID, currentDivision.division_ID), 4000);
                    }
                    else {
                        setIsLoading(false);
                    }
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                });
        //console.log(response);
    }

    const copyNewDivision = async () => {
        refreshToken();
        currentDivision.vbasoftware_database = currentDB;
        const response =
            await axios
                .post(
                    localStorage.getItem('baseURL') + 'division/copy',
                    {groupID: currentDivision.group_ID, sourceDivisionID: currentDivision.division_ID, destinationDivisionID: copyDivision.destinationDivisionID,
                        destinationDivisionName: copyDivision.destinationDivisionName, vbasoftware_database: currentDivision.vbasoftware_database},
                    {headers: {'Authorization': `Bearer ${token}`}}
                ).then(() => {
                    setIsLoading(false);
                    setLoading(false);
                    setSuccessMessage("New Division Created!");
                    setSuccessAlert(true);
                    getDivisionList();
                }).catch((error) => {
                    setIsLoading(false);
                    setLoading(false);
                    setValidationText(error.response.text);
                    setValidationError(true);
                    //console.log(response);
                });
        //console.log(response);
    }
    //const plans: TreeViewBaseItem<{ plan_ID: string; description: string; plan_typer: string; }>[] = getPlanList().then(data => ());

    //const getItemId = (item: treeDivisions) => item.children.id;

    return (
        <div>
            <Box sx={{overflowY: 'scroll', border: '2px solid #3B6BA3', background: '#3B6BA3', borderRadius: '10px', maxWidth: '13%', minWidth: '13%'}}
                 style={{float: "right", minHeight: '70vh', maxHeight: '70vh'}}>
                <div style={{padding: "1vh", marginLeft: '2vh'}}><b>Group Divisions</b></div>
                <RichTreeView items={divisions} slots={{item: CustomTreeItem}}
                              onSelectedItemsChange={handleTreeViewSelect}/>
            </Box>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="divisionFormContainer">

                    {/* Row 1: Group, Division ID, Name, Coverage Start, Coverage End */}
                    <div className="divisionFormRow-5col">
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Group</span>
                            <TextField name="group_ID" variant="outlined" className="divisionInput" size="small"
                                       value={currentDivision.group_ID} onChange={handleChange}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Division ID</span>
                            <TextField name="division_ID" variant="outlined" className="divisionInput" size="small"
                                       value={currentDivision.division_ID} onChange={handleChange}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Name</span>
                            <TextField name="division_name" variant="outlined" className="divisionInput" size="small"
                                       value={currentDivision.division_name} onChange={handleChange}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Coverage Start</span>
                            <DatePicker className="date-pickerDivisionCovDate"
                                        value={currentDivision.division_contract_coverage_Start ? dayjs(currentDivision.division_contract_coverage_Start) : null}
                                        onChange={handleCovStartDateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Coverage End</span>
                            <DatePicker className="date-pickerDivisionCovDate"
                                        value={currentDivision.division_contract_coverage_End ? dayjs(currentDivision.division_contract_coverage_End) : null}
                                        onChange={handleCovEndDateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                    </div>

                    {/* Row 2: Plan Years + Original Date */}
                    <div className="divisionFormRow-7col">
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Plan Year 1</span>
                            <TextField name="division_plan_Year_1" variant="outlined" className="divisionPlanYearInput" size="small"
                                       value={currentDivision.division_plan_Year_1} onChange={handleChange}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">PY1 From</span>
                            <DatePicker className="date-pickerDivisionPlanYearDate"
                                        value={currentDivision.plan_Year_1_From_Date ? dayjs(currentDivision.plan_Year_1_From_Date) : null}
                                        onChange={handlePlanYear1FromDateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">PY1 Thru</span>
                            <DatePicker className="date-pickerDivisionPlanYearDate"
                                        value={currentDivision.plan_Year_1_Thru_Date ? dayjs(currentDivision.plan_Year_1_Thru_Date) : null}
                                        onChange={handlePlanYear1ThruDateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Plan Year 2</span>
                            <TextField name="division_plan_Year_2" variant="outlined" className="divisionPlanYearInput" size="small"
                                       value={currentDivision.division_plan_Year_2} onChange={handleChange}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">PY2 From</span>
                            <DatePicker className="date-pickerDivisionPlanYearDate"
                                        value={currentDivision.plan_Year_2_From_Date ? dayjs(currentDivision.plan_Year_2_From_Date) : null}
                                        onChange={handlePlanYear2FromDateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">PY2 Thru</span>
                            <DatePicker className="date-pickerDivisionPlanYearDate"
                                        value={currentDivision.plan_Year_2_Thru_Date ? dayjs(currentDivision.plan_Year_2_Thru_Date) : null}
                                        onChange={handlePlanYear2ThruDateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Original Date</span>
                            <DatePicker className="date-pickerDivisionOrigDate"
                                        value={currentDivision.original_Date ? dayjs(currentDivision.original_Date) : null}
                                        onChange={handleOriginalDateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                    </div>

                    {/* Row 3: Networks — 3 × (Autocomplete | Priority | Eff Date) */}
                    <div className="divisionFormRow-network">
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Network 1</span>
                            <Autocomplete className="divisionNetworkSelect" size="small" disablePortal
                                          options={networks}
                                          value={currentDivision.division_Network1?.networkID ? currentDivision.division_Network1 : null}
                                          getOptionLabel={(option: any) => option.networkDescription || ""}
                                          isOptionEqualToValue={(option: any, value: any) => option.networkID === value.networkID}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={handleNetwork1Select}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Priority</span>
                            <TextField name="division_Network1_Priority" variant="outlined" className="divisionPriorityInput" size="small"
                                       value={currentDivision.division_Network1_Priority} onChange={handleChange}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Eff Date</span>
                            <DatePicker className="date-pickerNetworkEffDate"
                                        value={currentDivision.division_Network1_Eff_Date ? dayjs(currentDivision.division_Network1_Eff_Date) : null}
                                        onChange={handleDivision_Network1_Eff_DateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Network 2</span>
                            <Autocomplete className="divisionNetwork2Select" size="small" disablePortal
                                          options={networks}
                                          value={currentDivision.division_Network2?.networkID ? currentDivision.division_Network2 : null}
                                          getOptionLabel={(option: any) => option.networkDescription || ""}
                                          isOptionEqualToValue={(option: any, value: any) => option.networkID === value.networkID}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={handleNetwork2Select}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Priority</span>
                            <TextField name="division_Network2_Priority" variant="outlined" className="divisionPriorityInput" size="small"
                                       value={currentDivision.division_Network2_Priority} onChange={handleChange}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Eff Date</span>
                            <DatePicker className="date-pickerNetworkEffDate"
                                        value={currentDivision.division_Network2_Eff_Date ? dayjs(currentDivision.division_Network2_Eff_Date) : null}
                                        onChange={handleDivision_Network2_Eff_DateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div><div className="divisionFormField">
                        <span className="divisionFieldLabel">Network 3</span>
                        <Autocomplete className="divisionNetwork3Select" size="small" disablePortal
                                      options={networks}
                                      value={currentDivision.division_Network3?.networkID ? currentDivision.division_Network3 : null}
                                      getOptionLabel={(option: any) => option.networkDescription || ""}
                                      isOptionEqualToValue={(option: any, value: any) => option.networkID === value.networkID}
                                      renderInput={(params) => <TextField {...params}/>}
                                      onChange={handleNetwork3Select}/>
                    </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Priority</span>
                            <TextField name="division_Network3_Priority" variant="outlined" className="divisionPriorityInput" size="small"
                                       value={currentDivision.division_Network3_Priority} onChange={handleChange}/>
                        </div>
                        <div className="divisionFormField">
                            <span className="divisionFieldLabel">Eff Date</span>
                            <DatePicker className="date-pickerNetworkEffDate"
                                        value={currentDivision.division_Network3_Eff_Date ? dayjs(currentDivision.division_Network3_Eff_Date) : null}
                                        onChange={handleDivision_Network3_Eff_DateChange}
                                        slotProps={{textField: {size: 'small', fullWidth: true}}}/>
                        </div>
                    </div>

                    {/* Row 4: Plans (half width, centered) */}
                    <div className="divisionFormRow-halfCenter">
                        <div className="divisionFormField-half">
                            <span className="divisionFieldLabel">Plans</span>
                            <Autocomplete className="divisionPlanSelect" multiple size="small" limitTags={3} disablePortal
                                          options={plans}
                                          value={currentDivision.division_plans}
                                          renderInput={(params) => <TextField {...params}/>}
                                          onChange={handlePlanSelect}
                                          isOptionEqualToValue={(option: any, value: any) => option === value}/>
                        </div>
                    </div>

                    {/* Row 5: Checkboxes + New Contract Plans */}
                    <div className="divisionFormRow-4col">
                        <div className="divisionFormField divisionFormField-checkbox">
                            <span className="divisionFieldLabel">Contract Change</span>
                            <Checkbox name="contractChange" checked={currentDivision.contractChange} onChange={handleCheck}/>
                        </div>
                        <div className="divisionFormField divisionFormField-checkbox">
                            <span className="divisionFieldLabel">Copy Network</span>
                            <Checkbox name="copyNetwork" checked={currentDivision.copyNetwork} onChange={handleCheck}/>
                        </div>
                        <div className="divisionFormField divisionFormField-checkbox">
                            <span className="divisionFieldLabel">Re-Enroll</span>
                            <Checkbox name="reenroll" checked={currentDivision.reenroll} onChange={handleCheck}/>
                        </div><div className="divisionFormField">
                        <span className="divisionFieldLabel">New Contract Plans</span>
                        <Autocomplete className="divisionPlanSelect" multiple size="small" limitTags={1} disablePortal
                                      options={plans}
                                      value={currentDivision.newContractPlans}
                                      renderInput={(params) => <TextField {...params}/>}
                                      onChange={handlenewContractPlanSelect}
                                      isOptionEqualToValue={(option: any, value: any) => option === value}/>
                    </div>
                    </div>

                    {/* Row 6: Copy section */}
                    <div className="copyDivisionOutline">
                        <div className="divisionFormRow-2col">
                            <div className="divisionFormField">
                                <span className="divisionFieldLabel">Copy — Destination Division ID</span>
                                <TextField name="destinationDivisionID" variant="outlined" className="copyDivisionInput" size="small"
                                           value={copyDivision.destinationDivisionID} onChange={handleCopyChange}/>
                            </div><div className="divisionFormField">
                            <span className="divisionFieldLabel">Destination Division Name</span>
                            <TextField name="destinationDivisionName" variant="outlined" className="copyDivisionInput" size="small"
                                       value={copyDivision.destinationDivisionName} onChange={handleCopyChange}/>
                        </div>
                        </div>
                    </div>

                </div>
            </LocalizationProvider>

            <Dialog open={validationError} onClose={handleValidationClose}
                    aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Validation Error"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{validationText}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={validationSuccess} onClose={handleAllDivisionClose}
                    aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Attention"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Do you want these changes to apply to only this division or all divisions in the group?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAllDivisionsSelect}>All</Button>
                    <Button onClick={handleOneDivisionsSelect}>Only One</Button>
                </DialogActions>
            </Dialog>

            {successAlert &&
                <Alert className="divisionAlertStyles" severity="success" onClose={() => setSuccessAlert(false)} variant="filled">
                    <AlertTitle>Success!</AlertTitle>
                    {successMessage}
                </Alert>}<Stack spacing={5} direction="row" className="divisionButtonBar">
            <Autocomplete className="dbSelect" size="small" disablePortal disableClearable
                          options={GlobalConstants.VBA_DB}
                          value={GlobalConstants.VBA_DB.find(option => option.id === currentDB) || null}
                          sx={{width: 150}} defaultValue={GlobalConstants.VBA_DB[0]}
                          renderInput={(params) => <TextField {...params}/>}
                          onChange={onDBChange}/>
            <Button variant="contained" onClick={clearDivision} size="large">Clear</Button>
            <LoadingButton variant="contained" onClick={validateDivision} size="large"
                           loading={loading} loadingPosition="start" startIcon={<SaveIcon/>}>Save</LoadingButton>
            <LoadingButton variant="contained" onClick={validateCopy} size="large"
                           loading={loading} loadingPosition="start" startIcon={<FileCopyIcon/>}>Copy</LoadingButton>
        </Stack><Backdrop sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={isLoading}>
            <CircularProgress color="inherit"/>
        </Backdrop>
        </div>
    );
}

export default React.memo(DivisionManager);